import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const regions = [
  'United States',
  'United Kingdom',
  'European Union',
  'Middle East',
  'Cyprus',
  'Mainland China',
  'Switzerland',
  'Singapore',
  'Hong Kong',
  'Dubai',
  'London',
  'New York',
];

const InternationalReach = () => {
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  const marqueeRef = useRef(null);

  return (
    <section className="relative py-24 md:py-32 bg-[#1a2332] overflow-hidden">
      {/* Decorative gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#c9a961]/5 via-transparent to-[#c9a961]/5" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        {/* Section header */}
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <span className="text-sm text-[#c9a961] uppercase tracking-wider mb-4 block">Global Presence</span>
          <h2 className="font-serif text-4xl md:text-6xl text-white mb-6 leading-tight">
            International Reach
          </h2>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Serving sophisticated clients across major financial and business centers worldwide
          </p>
        </motion.div>

        {/* Slow editorial marquee */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : { opacity: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          className="relative overflow-hidden py-12 mb-12"
        >
          <div className="flex whitespace-nowrap animate-marquee">
            {/* Duplicate regions for seamless loop */}
            {[...regions, ...regions, ...regions].map((region, index) => (
              <span
                key={index}
                className="inline-flex items-center mx-8 font-serif text-3xl md:text-4xl text-[#c9a961]/70"
              >
                {region}
                <span className="mx-8 text-[#c9a961]/30">•</span>
              </span>
            ))}
          </div>
        </motion.div>

        {/* Key regions grid */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6"
        >
          {regions.slice(0, 6).map((region, index) => (
            <div
              key={index}
              className="group relative p-6 bg-gradient-to-br from-[#0f1419]/50 to-[#1a2332]/50 border border-[#c9a961]/20 hover:border-[#c9a961]/50 transition-all duration-500 text-center"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-[#c9a961]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <span className="relative text-white font-medium group-hover:text-[#c9a961] transition-colors duration-500">
                {region}
              </span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default InternationalReach;
